import { environment } from 'environments/environment';

/** Tenant routes use app **code** in the path (e.g. `/api/outbox/{org}/dms`), not numeric id. */
export function resolveTenantAppCode(): string {
    const fromApp = `${environment.app?.code || ''}`.trim().toLowerCase();
    if (fromApp) {
        return fromApp;
    }

    if (typeof window !== 'undefined') {
        const host = (window.location.hostname || '').toLowerCase();
        if (host === 'services.ashcorp.xyz' || host === 'services.ashcorp.co') {
            return 'services';
        }
        if (host === 'bo.ashcorp.xyz' || host === 'bo.ashcorp.co') {
            return 'services';
        }
        if (host === 'cc.ashcorp.xyz' || host === 'cc.ashcorp.co') {
            return 'cc';
        }
    }

    return 'outbox';
}

export function resolveTenantOrganizationCode(): string {
    return (
        environment.selection?.organization?.code ??
        environment.selection?.organization?.slug ??
        'default'
    );
}

/** `/api/{appCode}/{organizationCode}/{moduleCode}` */
export function buildTenantApiPrefix(moduleCode: string): string {
    const module = `${moduleCode || ''}`.trim().toLowerCase();
    return `/api/${resolveTenantAppCode()}/${resolveTenantOrganizationCode()}/${module}`;
}
